import {
  UnifiedMonitoringWSConnection,
  WsConnectionStatus,
} from '@hakimo-ui/hakimo/types';
import { createContext, useContext } from 'react';

const defaultValue: UnifiedMonitoringWSConnection = {
  connectionState: {
    status: WsConnectionStatus.PENDING,
    isDuplicateSession: false,
  },
};

export const UnifiedMonitoringWsContext = createContext(defaultValue);

export function useUnifiedMonitoringWs() {
  const httpClient = useContext(UnifiedMonitoringWsContext);
  return httpClient;
}
